import { ResourceRefType, type Booking } from '../../../models/Scheduling'

export const reschedulePath = (bookingId: string) => `/scheduling/reschedule/${bookingId}`

export const scheduledTabPath = '/scheduling/scheduled'

export const meetingPrepPath = (roomId: string, sessionId: string) => `/workspace/upcoming/room/${roomId}/session/${sessionId}/`

export const pastMeetingPath = (roomId: string, sessionId: string) => `/workspace/past-meetings/room/${roomId}/session/${sessionId}/`

export interface MeetingPrepIds {
  roomId: string
  sessionId: string
}

export const getMeetingPrepIds = (booking: Booking): MeetingPrepIds | undefined => {
  if (!booking.room || !booking.session) {
    return undefined
  }
  const roomId = booking.session.ids.roomId ?? booking.room.ids.roomId
  const sessionId = booking.session.ids.sessionId
  if (!roomId || !sessionId) {
    return undefined
  }
  return { roomId, sessionId }
}

export const getSourceMeetingIds = (booking: Booking): MeetingPrepIds | undefined => {
  if (booking.source?.type !== ResourceRefType.SESSION) {
    return undefined
  }
  const { roomId, sessionId } = booking.source.ids
  if (!roomId || !sessionId) {
    return undefined
  }
  return { roomId, sessionId }
}
